import { guardChildNodeByType, parseChildrenWithoutText } from '@utils/ast';
import { accordionComponentParsers } from './component.accordion.js';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { sliderComponentParsers } from './component.slider.js';
import { textComponentParsers } from './component.text.js';

const parseGridComponent = (node, context) => {
  const children = Array.from(node.childNodes).filter(guardChildNodeByType("Column")).map((it) => parseGridColumn(it, context)).filter((panel) => panel !== null);
  if (children.length === 0) {
    return null;
  }
  return {
    nodeType: "grid-component",
    id: node.getAttribute("id") ?? void 0,
    children
  };
};
function parseGridColumn(node, context) {
  return {
    nodeType: "grid-component.column",
    meta: {
      size: parseInt(node.getAttribute("size") ?? "0", 10) || 1
    },
    children: parseChildrenWithoutText(
      node,
      {
        ...accordionComponentParsers,
        ...gridComponentParsers,
        ...iframeComponentParsers,
        ...imageComponentParsers,
        ...mediaComponentParsers,
        ...sliderComponentParsers,
        ...textComponentParsers
      },
      context.depth + 1
    )
  };
}
const gridComponentParsers = {
  rows: parseGridComponent
};

export { gridComponentParsers };
//# sourceMappingURL=component.grid.js.map
